// extracted by mini-css-extract-plugin
export var box = "MobileMenu-module--box--67371";
export var box_md = "MobileMenu-module--box_md--4900e";
export var box_xmd = "MobileMenu-module--box_xmd--cae92";
export var box_flex = "MobileMenu-module--box_flex--75211";
export var box_lg = "MobileMenu-module--box_lg--ca21d";
export var box_sm = "MobileMenu-module--box_sm--439b6";
export var box_outer = "MobileMenu-module--box_outer--968e8";
export var box_whiteBg = "MobileMenu-module--box_white-bg--16a1f";
export var box_noMarginBottom = "MobileMenu-module--box_no-margin-bottom--f8656";
export var box_noPadding = "MobileMenu-module--box_no-padding--164c4";
export var box_outerGray = "MobileMenu-module--box_outer-gray--eab6c";
export var box_dark = "MobileMenu-module--box_dark--ccf01";
export var box_zIndex = "MobileMenu-module--box_z-index--b7dc6";
export var box_zIndex6 = "MobileMenu-module--box_z-index-6--fa407";
export var box_eventsWithLine = "MobileMenu-module--box_events-with-line--84fc6";
export var box_featuresAo = "MobileMenu-module--box_features-ao--8526f";
export var box_verticalPaddings = "MobileMenu-module--box_vertical-paddings--d37dd";
export var clearP = "MobileMenu-module--clearP--ef3e5";
export var clearP_vc = "MobileMenu-module--clearP_vc--69465";
export var mobileMenu = "MobileMenu-module--mobileMenu--7881f";
export var container = "MobileMenu-module--container--20f94";
export var fadeInAnimation = "MobileMenu-module--fadeInAnimation--efe9e";
export var placeHolderShimmer = "MobileMenu-module--placeHolderShimmer--3f8fc";